/**
 * Returns `true` if the given string is a LumApps document path (docPath).
 * A docPath is a key=value segment string of the form:
 * `provider={name}(/key=value)*`
 *
 * Examples:
 * - `provider=local/site=123`
 * - `provider=local/site=123/resource=456`
 * - `provider=haussmann_media/drive=abc/resource=xyz`
 */
export const isDocPath = (value: string | null | undefined): boolean =>
    Boolean(value && /^provider=[a-zA-Z0-9_]+(\/.+=.+)*$/.test(value));
